import React from "react";
import Vlog from "../components/vlogs/Vlog";

const VlogPage = () => {
  return (
    <section id="vlog">
      <Vlog />
    </section>
  );
};

export default VlogPage;
